/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { NodeDependencies } from './dependenciesNode.generated.js';
import { createArrayNode } from '../../factoriesAny.js';
export var ArrayNodeDependencies = {
  NodeDependencies,
  createArrayNode
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesArrayNode.generated.js
// module id = 180
// module chunks = 2